__turbopack_context__.v({
  "fieldContainer": "CarSelectionForm-module__23EVqW__fieldContainer",
  "makeField": "CarSelectionForm-module__23EVqW__makeField",
  "manufacturingYearField": "CarSelectionForm-module__23EVqW__manufacturingYearField",
  "modelField": "CarSelectionForm-module__23EVqW__modelField",
  "validationErrorContainer": "CarSelectionForm-module__23EVqW__validationErrorContainer",
  "validationErrorMake": "CarSelectionForm-module__23EVqW__validationErrorMake",
  "validationErrorManufacture": "CarSelectionForm-module__23EVqW__validationErrorManufacture",
  "validationErrorModel": "CarSelectionForm-module__23EVqW__validationErrorModel",
  "validationErrorVariant": "CarSelectionForm-module__23EVqW__validationErrorVariant",
  "validationErrorVehicleType": "CarSelectionForm-module__23EVqW__validationErrorVehicleType",
  "validationErrorWeight": "CarSelectionForm-module__23EVqW__validationErrorWeight",
  "validationErrorYear": "CarSelectionForm-module__23EVqW__validationErrorYear",
  "variantField": "CarSelectionForm-module__23EVqW__variantField",
  "vehicleTypeField": "CarSelectionForm-module__23EVqW__vehicleTypeField",
  "weightField": "CarSelectionForm-module__23EVqW__weightField",
  "yearField": "CarSelectionForm-module__23EVqW__yearField",
});
